var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "div",
        { staticClass: "jzliu-bi-engine-data-chart-preview" },
        [
          _vm.mode !== "drawer"
            ? [
                _c(
                  "el-dialog",
                  {
                    attrs: {
                      top: "5vh",
                      width: "90%",
                      visible: _vm.dialogVisible,
                      "append-to-body": "",
                      title: _vm.title,
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.dialogVisible = $event
                      },
                    },
                  },
                  [
                    _c("chart-data-table", {
                      attrs: { selectItem: _vm.chartData, data: _vm.data },
                      on: { "sort-change": _vm.handleSortChange },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c(
                  "el-drawer",
                  {
                    staticClass: "jzliu-bi-engine-dws-preview-drawer",
                    attrs: {
                      modal: false,
                      visible: _vm.dialogVisible,
                      direction: _vm.direction,
                      title: _vm.title,
                      "append-to-body": "",
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.dialogVisible = $event
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      { attrs: { slot: "title" }, slot: "title" },
                      [
                        _c("span", [_vm._v(_vm._s(_vm.title))]),
                        _vm._v(" "),
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "仅展示最近1000条数据",
                              placement: "right",
                            },
                          },
                          [_c("i", { staticClass: "el-icon-info" })]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("chart-data-table", {
                      attrs: { selectItem: _vm.chartData, data: _vm.data },
                      on: { "sort-change": _vm.handleSortChange },
                    }),
                  ],
                  1
                ),
              ],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }